// 课程方api
import { baseRequest } from './base'

/**
 * @desc 查询课程方列表
 */
function getInstitutionList(params) {
  //清除空白字段
  params = utils.common.checkNull(params)
  let tempUrl = '/api/pcWeb/teaInstitution/'
  return baseRequest(tempUrl, 'get', params)
}

/**
 * @desc 根据课程方ID获取课程方信息
 */
function getInstitutionById(id) {
  return baseRequest(`/api/pcWeb/teaInstitution/${id}`, 'get')
}

/**
 * @desc 新增课程方
 */
function addInstitution(params) {
  return baseRequest(`/api/pcWeb/teaInstitution/create`, 'post', params)
}

/**
 * @desc 删除课程方
 */
function deleteInstitution(id) {
  return baseRequest(`/api/pcWeb/teaInstitution/delete/${id}`, 'get')
}

/**
 * @desc 修改课程方
 */
function updateInstitution(id, params) {
  return baseRequest(`/api/pcWeb/teaInstitution/update/${id}`, 'post', params)
}

/**
 * @desc 课程方列表，支持课程方名字模糊查询
 */
function searchInstitution(params) {
  let tempUrl = '/api/pcWeb/teaInstitution/selectSearch'
  return baseRequest(tempUrl, 'get', params)
}

/**
 * @desc 课程评价页面课程方列表，支持课程方名字模糊查询
 */
function assessSearchInstitution(params) {
  let tempUrl = '/api/pcWeb/teaInstitution/selectSearch'
  return baseRequest(tempUrl, 'get', params)
}

/**
 * @desc 课程方类型
 */
function getInstitutionClassify() {
  return baseRequest(`/api/pcWeb/teaInstitution/getInstitutionClassify`, 'get')
}

/**
 * @desc 课程方入驻-第一步
 */
function enterInstitution(params) {
  return baseRequest(
    `/api/pcWeb/teaInstitution/enterInstitution`,
    'post',
    params
  )
}

/**
 * @desc 课程方入驻-课程方完善信息
 */
function supplementInfo(params) {
  params = utils.common.checkNull(params)
  return baseRequest(`/api/pcWeb/teaInstitution/supplementInfo`, 'post', params)
}

/**
 * @desc 撤销审核
 */
function revokeCheck(id) {
  return baseRequest(`/api/pcWeb/teaInstitution/revokeCheck/${id}`, 'get')
}

/**
 * @desc 根据用户查询课程方
 */
function getInstitutionByUser() {
  return baseRequest(`/api/pcWeb/teaInstitution/getInstitutionByUser`, 'get')
}

/**
 * @desc 审核
 */
function check(id, params) {
  return baseRequest(`/api/pcWeb/teaInstitution/check/${id}`, 'post', params)
}

/**
 * @desc 确认保证金
 */
function confirmCashDeposit(params) {
  return baseRequest(
    `/api/pcWeb/teaInstitution/confirmCashDeposit`,
    'post',
    params
  )
}

/**
 * @desc 核实
 */
function institutionVerify(params) {
  params = utils.common.checkNull(params)
  return baseRequest(
    `/api/pcWeb/teaInstitution/institutionInformationVerify`,
    'post',
    params
  )
}
// 课程方收费设置&白名单
function getInstitutionSetting() {
  let tempUrl = '/api/pcWeb/teaBureauSetting/getBureauSettingAndWhitelist'
  return baseRequest(tempUrl, 'get')
}
// 课程方管理
function loginInstitutionByPlatformAdmin(institutionId) {
  let tempUrl = '/api/pcWeb/loginIBPA?inst=' + institutionId;
  return baseRequest(tempUrl, 'get')
}

export default {
  getInstitutionList: getInstitutionList,
  getInstitutionById: getInstitutionById,
  addInstitution: addInstitution,
  deleteInstitution: deleteInstitution,
  updateInstitution: updateInstitution,
  searchInstitution: searchInstitution,
  getInstitutionClassify: getInstitutionClassify,
  enterInstitution: enterInstitution,
  supplementInfo: supplementInfo,
  revokeCheck: revokeCheck,
  getInstitutionByUser: getInstitutionByUser,
  check: check,
  confirmCashDeposit: confirmCashDeposit,
  institutionVerify,
  assessSearchInstitution,
  getInstitutionSetting,
  loginInstitutionByPlatformAdmin
}
